import {IconButton} from '@dropbox/dig-components/buttons';
import {Tooltip} from '@dropbox/dig-components/tooltips';
import {Box} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {CheckmarkCircleFill, CheckmarkCircleLine} from '@dropbox/dig-icons/assets';
import {t} from 'i18next';

export const ThreadButtons = ({
  resolved,
  onResolveClick,
}: {
  resolved: boolean;
  onResolveClick: (isResolved: boolean) => void;
}) => (
  <Box display="flex" alignItems="center">
    <Tooltip title={t(resolved ? 'comment_unresolve_tooltip' : 'comment_resolve_tooltip')}>
      <IconButton
        size="small"
        variant="transparent"
        onClick={(e: any) => {
          e.stopPropagation();
          onResolveClick(!resolved);
        }}
        aria-label="icon button"
      >
        <UIIcon src={resolved ? CheckmarkCircleFill : CheckmarkCircleLine} />
      </IconButton>
    </Tooltip>
  </Box>
);
